var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_31971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02991 0 0 4.02991 0 9C0 13.9701 4.02991 18 9 18C13.9701 18 18 13.9701 18 9C18 4.02991 13.9701 0 9 0ZM9 16.4732C4.87366 16.4732 1.52679 13.1263 1.52679 9C1.52679 4.87366 4.87366 1.52679 9 1.52679C13.1263 1.52679 16.4732 4.87366 16.4732 9C16.4732 13.1263 13.1263 16.4732 9 16.4732Z",
    fill: "black",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0354 5.46429C8.0354 5.72003 8.13699 5.9653 8.31783 6.14614C8.49867 6.32698 8.74394 6.42857 8.99969 6.42857C9.25543 6.42857 9.5007 6.32698 9.68154 6.14614C9.86238 5.9653 9.96397 5.72003 9.96397 5.46429C9.96397 5.20854 9.86238 4.96327 9.68154 4.78243C9.5007 4.60159 9.25543 4.5 8.99969 4.5C8.74394 4.5 8.49867 4.60159 8.31783 4.78243C8.13699 4.96327 8.0354 5.20854 8.0354 5.46429ZM9.48183 7.71429H8.51754C8.42915 7.71429 8.35683 7.78661 8.35683 7.875V13.3393C8.35683 13.4277 8.42915 13.5 8.51754 13.5H9.48183C9.57022 13.5 9.64254 13.4277 9.64254 13.3393V7.875C9.64254 7.78661 9.57022 7.71429 9.48183 7.71429Z",
    fill: "black",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_31971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDetail);
export default __webpack_public_path__ + "static/media/ic_detail.450476cbb03a625c4dc559e6cab52276.svg";
export { ForwardRef as ReactComponent };